import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { BreadcrumbItemViewModel } from 'autogen/swagger/all';
import { Back } from 'autogen/translation-keys/trans-website-shared';
import { Button } from 'components/Button';
import { Typography } from 'components/generic/typography';
import Icon from 'components/Icon';
import useRequestContext from 'hooks/user/useRequestContext';
import { breakpoint, sizes } from 'variables';

export type BackButtonProps = {
    model?: BreadcrumbItemViewModel;
};

const Wrapper = styled.div`
    display: flex;
    height: 50px;
    align-items: center;

    ${breakpoint.up(sizes.md)} {
        background: transparent;
    }
`;

const PipeDivider = styled.div`
    width: 1px;
    height: 1.2rem;
    background: ${({ theme }) => theme.ColorIconPrimary};
    margin: 0;
`;

const StyledIcon = styled(Icon)`
    margin-right: ${({ theme }) => theme.Spacing8};
`;

export default function BackButton(props: BackButtonProps) {
    const { model } = props;
    const { t } = useTranslation();
    const { supportsNativeBackArrow } = useRequestContext();

    function handleClick(e) {
        e.preventDefault();
        const { referrer } = document;
        if (referrer) {
            window.history.back();
        } else if (model?.linkAction) {
            window.location.href = model.linkAction.url;
        }
    }

    if (supportsNativeBackArrow) return null;

    return (
        <Wrapper>
            <Button.WithIcon variant="ghost" icon={<StyledIcon size={16} type="ChevronLeft" />} onClick={handleClick}>
                <Typography.Label size="M">{t(Back)}</Typography.Label>
            </Button.WithIcon>
            <PipeDivider />
        </Wrapper>
    );
}
